import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chipInProgress: {
      margin: '0.25vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      backgroundColor: '#000A8C',
      color: '#FFFFFF',
      paddingLeft: '10px',
      paddingRight: '12px',
      paddingTop: 2,
      paddingBottom: 2,
      borderRadius: 28,
    },
    textInProgress: {
      fontSize: 14,
      fontFamily: 'Poppins',
      fontWeight: 400,
      color: '#FFFFFF',
      lineHeight: 1.4,
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
      },
    },
  })
);
